mydirective.$inject = [];

function mydirective() {
    return {
        restrict: "A",
        link: function (scope, elem, attrs) {
            $(elem).click(function () {
                var card = $(elem).parent('.material-card');
                var icon = $(elem).children('i');
                icon.addClass('fa-spin-fast');

                if (card.hasClass('mc-active')) {
                    card.removeClass('mc-active');

                    window.setTimeout(function () {
                        icon
                            .removeClass('fa-arrow-left')
                            .removeClass('fa-spin-fast')
                            .addClass('fa-bars');

                    }, 800);
                } else {
                    card.addClass('mc-active');

                    window.setTimeout(function () {
                        icon
                            .removeClass('fa-bars')
                            .removeClass('fa-spin-fast')
                            .addClass('fa-arrow-left');

                    }, 800);
                }
            });
        }
    };
}
module.exports = ngModule => {
    ngModule.directive('mydirective', mydirective);
};